module.exports = __webpack_public_path__ + "static/CBS-4bd562b079270b01dd3ef50bcf5f778c.png";